export default "__VITE_ASSET__BXIvaYih__"